import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: '0px',
    width: '100%',
    height: '100%'
  },
  radioButton: {
    className: 'no-format',
    style: { display: 'none' }
  },
  tocTitle: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    marginBottom: '8px'
  },
  textField: {
    width: '100%',
    '& .MuiInputBase-root': {
      height: '32px',
      margin: '0px',
      backgroundColor: 'transparent',
      '& .MuiInputBase-input': {
        padding: '0px 8px',
        border: 'none',
        backgroundColor: 'transparent',
        color: capitalDesignTokens.semanticColors.foreground.primary
      }
    }
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  switchControlLabel: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    padding: '0px',
    margin: '0px',
    marginBottom: '16px'
  },

  controls: {
    className: 'no-format',
    style: { display: 'none' }
  },
});
